import { configureStore , getDefaultMiddleware} from '@reduxjs/toolkit';
import  RootReducer  from '../slices/RootReducer';

const middleware = [
  ...getDefaultMiddleware(
    {
      serializableCheck: {
        ignoredActions: ['CasinoSlice/updateGameflexExpressLibrary'],
        ignoredPaths: ['CasinoSlice.gameflexExpressLibrary'],
      }
    }
  ),
];

export default configureStore({
  reducer: RootReducer,
  middleware
});



// WEBPACK FOOTER //
// ./src/app/stores/ReduxStore.js